import api from 'api'

export type PayoutToAchRequest = {
  userId: number
  userPaymentIds?: number[]
  comment: string
}

export type PayoutToAchResponse = {
  userPaymentId: number
  amount: number
}

export const payoutToAch = async (
  request: PayoutToAchRequest
): Promise<PayoutToAchResponse> => {
  const response = await api.post('/admin/payment/payout_to_ach', request)
  return response.data
}
